module.exports = __webpack_public_path__ + "img/-s-login.9c77b5bc.png";